__turbopack_context__.v({
  "dotPulse": "DotsSpinner-module__DhsATq__dotPulse",
  "root": "DotsSpinner-module__DhsATq__root",
});
